import React from "react";
import styles from "./styles.module.scss";

const ButtonsContainer = ({items, itemSelected, setItemSelected, containerStyle = ""}) => {

  return (
    <div className={containerStyle}>
      {items.map((item) => (
        <button
          key={item.value}
          onClick={() => setItemSelected(item)}
          className={`${
            itemSelected?.value === item.value
              ? styles.selected_btn
              : styles.default_btn
          } ${styles.base_btn}`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default ButtonsContainer;
